export default function initGlobalJS() {
  const objectPosition = document.querySelectorAll<HTMLElement>('.js-object-position');
  const isTouchDevice = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
  objectPosition.forEach((el) => {
    const { objectPositionMobile } = el.dataset;
    el.style.setProperty('object-position', (objectPositionMobile && isTouchDevice)
      ? objectPositionMobile
      : el.dataset.objectPosition as string);
  });

  document.addEventListener('onFormieInit', (event) => {
    // @ts-ignore Fetch the Form Factory once it's been loaded
    const { formie, formId } = event.detail;
    if (formie && formId) {
      // Refresh the necessary bits that are statically cached (CSRF inputs, captchas, etc)
      formie.refreshForCache(formId);
    }
  });

    const form = document.querySelector('.form-newsletter form');
    if (form) {
      form.addEventListener('onAfterFormieSubmit', () => {
        const successDialog = document.querySelector('#newsletter-success-dialog');
        if (successDialog) {
          // @ts-ignore
          successDialog.show();
        }
      });
    }
}
